import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Button } from "../../components";

const HireResearchAnalysts = () => {
	return (
		<main className='HireResearchAnalysts'>
			<Helmet>
				<title>Hire Research Analysts - Horizon Market Strategies</title>
				<meta
					name='description'
					content='Horizon Market Strategies (HMS), your trusted partner in delivering bespoke market research solutions aimed at equipping businesses with actionable insights.'
				/>
				<meta
					property='og:title'
					content='Home - Horizon Market Strategies'
				/>
				<meta
					property='og:description'
					content='Horizon Market Strategies (HMS), your trusted partner in delivering bespoke market research solutions aimed at equipping businesses with actionable insights.'
				/>
				<meta
					property='og:site_name'
					content='Horizon Market Strategies'
				/>
			</Helmet>
			<div className='HireResearchAnalysts__Container'>
				{/* TOP */}
				<div className='HireResearchAnalysts__Top'>
					<h1>
						Empower Your Business with <span>Expert Research Support</span>
					</h1>
					<p>
						At Horizon Market Strategies, we understand that quality research is the backbone of informed decision-making. That’s why we offer you the opportunity to hire our team of experienced research analysts to work on your projects, delivering insights that drive results.
					</p>
				</div>

				<div className='HireResearchAnalysts__Middle'>
					<h2>Why Hire Our Research Analysts?</h2>
					<div className="text-[1.8rem] font-[500] text-[#042E3E] flex items-center justify-between">
						<div className="w-1/2 flex justify-center items-center">
							<img src='/rb_7482.webp' alt='career' className='h-[34rem]' />
						</div>
						<div className="w-1/2">
							<ul className='list-disc pl-6 space-y-6 reports__BulletPoints'>
								<li>
									<strong>Dedicated Expertise:</strong> Access skilled professionals with extensive experience in market research, industry analysis, and data interpretation.
								</li>
								<li>
									<strong>Tailored Solutions:</strong> Our analysts adapt to your project needs, delivering insights and strategies unique to your business.
								</li>
								<li>
									<strong>Cost-Effective Resource:</strong> Save on recruitment, training, and infrastructure costs by leveraging our ready-to-deploy talent.
								</li>
								<li>
									<strong>Seamless Collaboration:</strong> Our team works as an extension of yours, ensuring smooth communication and timely delivery.
								</li>
								<li>
									<strong>Diverse Expertise:</strong> From market trends to competitive analysis, our analysts specialize in various domains and industries.
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div className='HireResearchAnalysts__Middle'>
					<h2>How We Help:</h2>
					<div className="text-[1.8rem] font-[500] text-[#042E3E] flex items-center justify-between">
						<div className="w-1/2">
							<ul className='list-disc pl-6 space-y-6 reports__BulletPoints'>
								<li>
									<strong>Customized Project Support:</strong> Share your requirements, and we’ll match you with the best-fit research analysts for your needs.
								</li>
								<li>
									<strong>Flexible Engagement Models:</strong> Hire analysts on a project, part-time, or full-time basis.
								</li>
								<li>
									<strong>Scalable Solutions:</strong> Scale up or down as your project evolves, ensuring you only pay for what you need.
								</li>
								<li>
									<strong>Actionable Insights:</strong> Receive detailed reports and actionable strategies to make informed decisions.
								</li>
							</ul>
						</div>
						<div className="w-1/2 flex justify-center items-center">
							<img src='/rb_6635.webp' alt='career' className='h-[34rem]' />
						</div>
					</div>
				</div>

				<section className='my-[5rem] w-full'>
					<div className='flex flex-col  justify-between w-full gap-5'>
						<div className='flex flex-col gap-2'>
							<h1 className='text-[#01212E] text-[21px] font-[400]'>Industries We Serve:</h1>
							<p className='text-[#01212E] text-[14px] font-[400]'>
								From consumer goods to packaging, capital goods to food and beverages, our analysts are equipped to handle research across diverse sectors.
							</p>
						</div>
					</div>
				</section>

				<div className='HireResearchAnalysts__Middle'>
					<h2>Why Horizon Market Strategies?</h2>
					<div className="text-[1.8rem] font-[500] text-[#042E3E] flex items-center justify-between">
						<div className="w-1/2 flex justify-center items-center">
							<img src='/rb_20407.webp' alt='career' className='h-[34rem]' />
						</div>
						<div className="w-1/2">
							<ul className='list-disc pl-6 space-y-6 reports__BulletPoints'>
								<li>
									<strong>Proven Track Record:</strong> Delivering high-quality research that drives results.
								</li>
								<li>
									<strong>Dedicated Team:</strong> A team committed to your success at every step.
								</li>
								<li>
									<strong>Transparent Processes:</strong> Ensuring measurable outcomes through clear and open methodologies.
								</li>
							</ul>
						</div>
					</div>
				</div>

				<section className='mt-[8rem] mb-[5rem] w-full'>
					<div className='w-full flex justify-center items-center'>
						<Link to='/company/contact-us' className='w-fit'>
							<Button
								text='Hire a Research Analyst Now!'
								className='button__Common max-lg:rounded-[0.2rem] w-fit px-10'
							/>
						</Link>
					</div>
				</section>
			</div>
		</main>
	);
};

export default HireResearchAnalysts;
